import Cancel from 'images/icons/Cancel.svg';

import { Icon } from 'components/Icon';
import { Text } from 'components/Text';

import styles from '../../Modal.module.scss';

interface HeaderProps {
  title?: string;
  id: string;
  onClose: () => void;
}

export function Header({ title, id, onClose }: HeaderProps) {
  const titleMarkup = title && (
    <div className={styles.Title}>
      <Text as="h2" size="extraLarge" variation="strong">
        {title}
      </Text>
    </div>
  );

  return (
    <div className={styles.Header} id={id}>
      {titleMarkup}
      <button
        className={styles.CloseButton}
        aria-label="Close"
        onClick={onClose}
      >
        <Icon source={Cancel} color="inherit" />
      </button>
    </div>
  );
}
